export default __webpack_public_path__ + "static/media/overnight2.675e0cf1.svg";